<template>
  <div class="qiniu-settings">
    <div class="settings-header">
      <h2>七牛云存储设置</h2>
      <p>配置您的七牛云存储参数，实现文件云存储功能</p>
    </div>

    <div class="settings-form">
      <div class="form-card">
        <div class="form-item">
          <label class="form-label">
            <span class="label-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </span>
            七牛云账号
          </label>
          <div class="input-wrapper">
            <input 
              v-model="form.account" 
              type="text" 
              placeholder="请输入七牛云账号"
              class="form-input"
            />
          </div>
        </div>

        <div class="form-item">
          <label class="form-label">
            <span class="label-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </span>
            七牛云密钥
          </label>
          <div class="input-wrapper">
            <input 
              v-model="form.secretKey" 
              type="password" 
              placeholder="请输入七牛云密钥"
              class="form-input"
            />
            <span class="input-suffix" @click="togglePassword">
              <svg v-if="showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </span>
          </div>
        </div>

        <div class="form-item">
          <label class="form-label">
            <span class="label-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
            </span>
            存储桶名称
          </label>
          <div class="input-wrapper">
            <input 
              v-model="form.bucket" 
              type="text" 
              placeholder="请输入存储桶名称"
              class="form-input"
            />
          </div>
        </div>

        <div class="form-actions">
          <button class="btn-save" @click="saveSettings">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17 21 17 13 7 13 7 21"></polyline>
              <polyline points="7 3 7 8 15 8"></polyline>
            </svg>
            保存配置
          </button>
          <button class="btn-test" @click="testConnection">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
            测试连接
          </button>
        </div>
      </div>

      <div class="tips-card">
        <div class="tips-header">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
          配置说明
        </div>
        <ul class="tips-list">
          <li>请确保您已在七牛云平台注册并创建了存储空间</li>
          <li>密钥信息可在七牛云控制台的"密钥管理"中获取</li>
          <li>存储桶名称需要与七牛云中创建的空间名称一致</li>
          <li>配置保存后，文件上传功能将自动使用七牛云存储</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QiniuSettings',
  data() {
    return {
      form: {
        account: '',
        secretKey: '',
        bucket: ''
      },
      showPassword: false
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    saveSettings() {
      if (!this.form.account) {
        this.$message.warning('请输入七牛云账号')
        return
      }
      if (!this.form.secretKey) {
        this.$message.warning('请输入七牛云密钥')
        return
      }
      if (!this.form.bucket) {
        this.$message.warning('请输入存储桶名称')
        return
      }
      this.$message.success('配置保存成功')
    },
    testConnection() {
      if (!this.form.account || !this.form.secretKey || !this.form.bucket) {
        this.$message.warning('请先完成配置信息填写')
        return
      }
      this.$message.success('连接测试成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.qiniu-settings {
  padding: 30px;
  background: linear-gradient(135deg, #f8f9fc 0%, #ffffff 100%);
  min-height: calc(100vh - 60px);
}

.settings-header {
  margin-bottom: 30px;
  
  h2 {
    font-size: 28px;
    font-weight: 700;
    background: linear-gradient(135deg, #1a1a2e, #4a4a68);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0 0 8px 0;
  }
  
  p {
    font-size: 14px;
    color: #8a8aa3;
    margin: 0;
  }
}

.settings-form {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 24px;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
}

.form-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 
    0 8px 32px rgba(94, 96, 206, 0.1),
    0 0 0 1px rgba(94, 96, 206, 0.05);
  border: 1px solid rgba(94, 96, 206, 0.08);
}

.form-item {
  margin-bottom: 28px;
  
  &:last-of-type {
    margin-bottom: 32px;
  }
}

.form-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 12px;
  
  .label-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: linear-gradient(135deg, rgba(94, 96, 206, 0.1), rgba(124, 127, 246, 0.05));
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    color: #5e60ce;
  }
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.form-input {
  width: 100%;
  height: 52px;
  padding: 0 20px;
  border-radius: 12px;
  border: 2px solid rgba(94, 96, 206, 0.1);
  background: #f8f9fc;
  font-size: 15px;
  color: #1a1a2e;
  transition: all 0.3s ease;
  
  &::placeholder {
    color: #b0b0c0;
  }
  
  &:focus {
    outline: none;
    border-color: #5e60ce;
    background: #ffffff;
    box-shadow: 0 4px 16px rgba(94, 96, 206, 0.15);
  }
}

.input-suffix {
  position: absolute;
  right: 16px;
  color: #8a8aa3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(94, 96, 206, 0.1);
    color: #5e60ce;
  }
}

.form-actions {
  display: flex;
  gap: 16px;
  
  button {
    flex: 1;
    height: 52px;
    border-radius: 12px;
    border: none;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.3s ease;
  }
  
  .btn-save {
    background: linear-gradient(135deg, #5e60ce, #7c7ff6);
    color: white;
    box-shadow: 0 4px 16px rgba(94, 96, 206, 0.3);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(94, 96, 206, 0.4);
    }
  }
  
  .btn-test {
    background: rgba(94, 96, 206, 0.08);
    color: #5e60ce;
    
    &:hover {
      background: rgba(94, 96, 206, 0.15);
    }
  }
}

.tips-card {
  background: linear-gradient(135deg, rgba(94, 96, 206, 0.05), rgba(46, 196, 182, 0.03));
  border-radius: 20px;
  padding: 24px;
  border: 1px solid rgba(94, 96, 206, 0.1);
  height: fit-content;
  
  .tips-header {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a2e;
    margin-bottom: 16px;
    
    svg {
      color: #5e60ce;
    }
  }
  
  .tips-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      font-size: 13px;
      color: #6a6a8a;
      line-height: 1.8;
      padding-left: 20px;
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 10px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: linear-gradient(135deg, #5e60ce, #7c7ff6);
      }
    }
  }
}
</style>
